import { h, Component, Fragment } from "preact";
import { Trans } from "@lingui/react/macro";
import {
    Cell,
    HCell,
    HRow,
    InputFilter,
    Pagination,
    Panel,
    PanelRow,
    Row,
    SelectFilter,
    CustomTable, PaginationV2
} from "./table-utils";
import Config from "../../../services/config";

export class PerPageFilter extends Component {
    state = {
        perPage: '',
        pageList: [10,30,60,100],
        onInput: () => {}
    }

    componentWillMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({perPage: this.state.perPage});
    }

    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Record Per Pagina</Trans></span>
            <SelectFilter class="inline-block bg-white py-2 leading-3 w-full" onChange={e => {this.state.perPage = e.currentTarget.value; this.onInput();}}>
                {this.state.pageList.map(n => <option value={n} selected={n === parseInt(this.state.perPage)}>{n}</option>)}
            </SelectFilter>
        </label>;
    }
}

export class OutcomeCodeFilter extends Component {
    state = {
        searchOutcome: false,
        onInput: () => {}
    }

    componentWillMount() {
        this.setState(this.props);
        window.addEventListener("message", this.postMessageListener = event => {
            console.info(event);
            this.state.searchOutcome = event.data;
            this.onInput();
        }, false);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.postMessageListener);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({searchOutcome: this.state.searchOutcome});
    }

    openHelpPopup() {
        window.open(
            Config.softionAPI + '/gamecontrol/index.php?controller=subfinancial&module=getOutcomesIDs',
            'outcomesWindow',
            'width=800,height=600,scrollbars=yes'
        );
    }

    render() {
        return <label class="mx-px px-2">
            <span class="block text-xs whitespace-pre"><Trans>Codice Esito</Trans></span>
            <InputFilter
                type="text"
                class="w-40 px-2 py-1 leading-6 rounded border"
                value={this.state.searchOutcome}
                onInput={e => {
                    this.state.searchOutcome = e.target.value;
                    this.onInput();
                }}
            />
            <a href="javascript:void(0);" class="ml-2" onClick={e => this.openHelpPopup()}><i class="fa-solid fa-circle-info text-blue-600" /></a>
        </label>;
    }
}

export class FromAcceptanceFilter extends Component {
    state = {
        searchStock: false,
        onInput: () => {}
    }

    componentWillMount() {
        this.props.searchStock = this.props.searchStock==='on';
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        nextProps.searchStock = nextProps.searchStock==='on';
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({searchStock: !!this.state.searchStock? 'on' : ''});
    }

    render() {
        return <label class="mx-px px-2">
            <span class="block text-xs whitespace-pre"><Trans>Da Riserva</Trans></span>
            <InputFilter
                type="checkbox"
                class="block mt-2 mb-3 m-auto"
                checked={this.state.searchStock}
                onInput={e => {
                    this.state.searchStock = !this.state.searchStock;
                    this.onInput();
                }}
            />
        </label>;
    }
}

export class SearchTypeFilter extends Component {
    state = {
        searchType: '',
        searchString: '',
        searchExact: false,
        onInput: () => {}
    }

    componentWillMount() {
        if (typeof this.props['searchExact'] !== 'undefined') {
            this.props.searchExact = this.props.searchExact==='on';
        }
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (typeof nextProps['searchExact'] !== 'undefined') {
            nextProps.searchExact = nextProps.searchExact==='on';
        }
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({
            searchType: this.state.searchType,
            searchString: this.state.searchString,
            searchExact: !!this.state.searchExact? 'on' : ''
        });
    }

    filterTypeList() {
        return {
            "0": <Trans>Smart</Trans>,
            "1": <Trans>Username</Trans>,
            "2": <Trans>ID Utente</Trans>,
            "3": <Trans>Indirizzo IP</Trans>,
            "4": <Trans>Palinsesto.Avvenimento</Trans>,
            "5": <Trans>Nome Evento</Trans>,
            "6": <Trans>ID Scommessa</Trans>,
            "7": <Trans>Vincita Maggiore Di...</Trans>,
            "8": <Trans>Scommessa Maggiore Di...</Trans>
        };
    }

    render() {
        return [
            <label class="mx-px">
                <span class="block text-xs"><Trans>Tipo Di Ricerca</Trans></span>
                <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchType = e.currentTarget.value; this.onInput();}}>
                    {Object.entries(this.filterTypeList()).map(
                        ([key,optiontext]) => <option value={key} selected={key === this.state.searchType}>{optiontext}</option>
                    )}
                </SelectFilter>
            </label>,
            <label class="mx-px">
                <span class="block text-xs"><Trans>Stringa Di Ricerca</Trans></span>
                <input type="input" class="w-40 px-2 py-1 leading-6 rounded border" value={this.state.searchString} onInput={e => {this.state.searchString = e.target.value; this.onInput();}} />
            </label>,
            <label class="mx-px px-2">
                <span class="block text-xs whitespace-pre"><Trans>Confronto Esatto</Trans></span>
                <InputFilter type="checkbox" class="block mt-2 mb-3 m-auto" checked={this.state.searchExact} onInput={e => {this.state.searchExact = !this.state.searchExact; this.onInput();}} />
            </label>
        ];
    }
}

export class EventsLeftCountFilter extends Component {
    state = {
        searchForPrese: '',
        onInput: () => {}
    }

    componentWillMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({searchForPrese: this.state.searchForPrese});
    }

    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Eventi Mancanti</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchForPrese = e.currentTarget.value; this.onInput();}}>
                <option value="" selected={0 === parseInt(this.state.searchForPrese)}><Trans>Tutti</Trans></option>
                {Array.from({length: 20}, (_, i) => i + 1).map(n => <option value={n} selected={n === parseInt(this.state.searchForPrese)}>{n}</option>)}
            </SelectFilter>
        </label>;
    }
}

export class TicketEventsCountFilter extends Component {
    state = {
        searchBetEvents: '',
        onInput: () => {}
    }

    componentWillMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({searchBetEvents: this.state.searchBetEvents});
    }

    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Numero Eventi</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchBetEvents = e.currentTarget.value; this.onInput();}}>
                <option value="0" selected={0 === parseInt(this.state.searchBetEvents)}><Trans>Tutti</Trans></option>
                {Array.from({length: 20}, (_, i) => i + 1).map(n => <option value={n} selected={n === parseInt(this.state.searchBetEvents)}>{n}</option>)}
            </SelectFilter>
        </label>;
    }
}

export class TicketTypeFilter extends Component {
    state = {
        searchBetType: '',
        onInput: () => {}
    }

    componentWillMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({searchBetType: this.state.searchBetType});
    }

    betTypeList() {
        return {
            "0": <Trans>Tutti</Trans>,
            "S": <Trans>Singola</Trans>,
            "M": <Trans>Multipla</Trans>,
            "R": <Trans>Sistema</Trans>,
            "L": <Trans>Live</Trans>
        };
    }

    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Tipo Scommessa</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchBetType = e.currentTarget.value; this.onInput();}}>
                {Object.entries(this.betTypeList()).map(
                    ([key,optiontext]) => <option value={key} selected={key === this.state.searchBetType}>{optiontext}</option>
                )}
            </SelectFilter>
        </label>;
    }
}

export class TicketStatusFilter extends Component {
    state = {
        searchStatus: '',
        onInput: () => {}
    }

    componentWillMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({searchStatus: this.state.searchStatus});
    }

    betStatusList() {
        return {
            "N": <Trans>Aperte</Trans>,
            "TZ": <Trans>Chiuse</Trans>,
            "Z": <Trans>Valide</Trans>,
            "V": <Trans>Vincenti</Trans>,
            "P": <Trans>Perdenti</Trans>,
            "A": <Trans>Annullate</Trans>,
            "D": <Trans>Rifiutate</Trans>,
            "S": <Trans>Sistemi Conclusi</Trans>,
            "R": <Trans>Riserve</Trans>,
            "PR": <Trans>Passate Dalla Riserva</Trans>,
            "C": <Trans>Da Confermare (lato utente)</Trans>,
            "M": <Trans>Da Monetizzare</Trans>,
            "CO": <Trans>Cashout</Trans>,
            "PAID": <Trans>Pagate</Trans>,
            "T": <Trans>Tutte</Trans>
        };
    }

    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Stato Scommessa</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.searchStatus = e.currentTarget.value; this.onInput();}}>
                {Object.entries(this.betStatusList()).map(
                    ([key,optiontext]) => <option value={key} selected={key === this.state.searchStatus}>{optiontext}</option>
                )}
            </SelectFilter>
        </label>;
    }
}

export class TicketEndDateFilter extends Component {
    state = {
        useTicketEnd: '',
        onInput: () => {}
    }

    componentWillMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    onInput() {
        this.state.onInput({useTicketEnd: this.state.useTicketEnd});
    }

    render() {
        return <label class="mx-px">
            <span class="block text-xs"><Trans>Ticket Conclusi...</Trans></span>
            <SelectFilter class="bg-white py-2" onChange={e => {this.state.useTicketEnd = e.currentTarget.value; this.onInput();}}>
                <option value="" selected={this.state.useTicketEnd === ''}><Trans>in qualsiasi momento</Trans></option>
                <option value="on" selected={this.state.useTicketEnd === 'on'}><Trans>entro la data fine</Trans></option>
            </SelectFilter>
        </label>;
    }
}

export class DateHelperFilter extends Component {
    state = {
        helperValue: 0,
        dateStartValue: null,
        dateEndValue: null,
        onInput: () => {}
    };

    componentWillMount() {
        this.state.helperValue = this.props.helperValue || 0;
        this.state.dateStartValue = this.props.dateStartValue;
        this.state.dateEndValue = this.props.dateEndValue;
        this.state.onInput = this.props.onInput;
        if (this.state.helperValue != 0)
            this.dateHelper(this.state.helperValue);
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.dateStartValue = nextProps.dateStartValue;
        this.state.dateEndValue = nextProps.dateEndValue;
        this.state.onInput = nextProps.onInput;
        this.setState(this.state);
    }

    onInput() {
        this.state.onInput({
            helperValue: this.state.helperValue,
            dateStartValue: this.state.dateStartValue,
            dateEndValue: this.state.dateEndValue
        });
    }

    formatDate(date) {
        let month = '' + (date.getMonth() + 1),
            day = '' + date.getDate(),
            year = date.getFullYear();

        if (month.length < 2) {
            month = '0' + month;
        }

        if (day.length < 2) {
            day = '0' + day;
        }

        return [year, month, day].join('-');
    }


    dateHelper(value) {
        this.state.helperValue = parseInt(value);

        if (this.state.helperValue > 0) {
            switch (this.state.helperValue) {
                case 1:
                    this.state.dateStartValue = this.formatDate(new Date());
                    this.state.dateEndValue = this.formatDate(new Date());
                    break;
                case 2:
                    this.state.dateStartValue = this.formatDate(new Date(Date.now() - 2 * 24 * 60 * 60 * 1000));
                    this.state.dateEndValue = this.formatDate(new Date());
                    break;
                case 3:
                    this.state.dateStartValue = this.formatDate(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
                    this.state.dateEndValue = this.formatDate(new Date());
                    break;
                case 4:
                    this.state.dateStartValue = this.formatDate(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));
                    this.state.dateEndValue = this.formatDate(new Date());
                    break;
            }
        }

        this.onInput();
    }

    render({firstChild, helperValue}) {
        return [
            <label class={"mx-px "+(firstChild || '')}>
                <span class="block text-sm"><Trans>Aiuto Data</Trans></span>
                <SelectFilter class={"text-black bg-white leading-3 w-full "+(this.props.class || ' py-2')} onChange={e => this.dateHelper(e.currentTarget.value)}>
                    <option value="0" selected={this.state.helperValue === 0}><Trans>Personalizzato</Trans></option>
                    <option value="1" selected={this.state.helperValue === 1}><Trans>Oggi</Trans></option>
                    <option value="2" selected={this.state.helperValue === 2}><Trans>Ultimi 2 Giorni</Trans></option>
                    <option value="3" selected={this.state.helperValue === 3}><Trans>Ultimi 7 Giorni</Trans></option>
                    <option value="4" selected={this.state.helperValue === 4}><Trans>Ultimi 30 Giorni</Trans></option>
                </SelectFilter>
            </label>,
            <label class="mx-px">
                <span class="block text-sm"><Trans>Data Inizio</Trans></span>
                <InputFilter
                    class={"text-black py-2 leading-3 w-full "+(this.props.class || '')}
                    type="date"
                    value={this.state.dateStartValue}
                    onInput={e => {
                        this.state.dateStartValue = e.target.value;
                        this.state.helperValue = 0;
                        this.onInput();
                    }}
                />
            </label>,
            <label class="mx-px">
                <span class="block text-sm"><Trans>Data Fine</Trans></span>
                <InputFilter
                    class={"text-black py-2 leading-3 w-full "+(this.props.class || '')}
                    type="date"
                    value={this.state.dateEndValue}
                    onInput={e => {
                        this.state.dateEndValue = e.target.value;
                        this.state.helperValue = 0;
                        this.onInput();
                    }}
                />
            </label>
        ];
    }
}

export class TableFormatter extends Component {
    state = {
        totalrecords: 0,
        recordperpage: 0,
        page: 0,
        lowlimit: 0,
        columns: [],
        data: [],
        colGroupMapper: false,
        class: "w-full table-auto border border-l-0",
        style: "",
        rowClass: '',
        cellClass: '',
        noFirstCell: false,
        //> Callback che si aspetta in output un singolo array con cui formattare le varie celle di ogni riga
        rowDataMapper: null,
        //> Callback che si aspetta in output un array di array, perchè per ogni iterazione ha la possibilità di creare nuove righe
        rowsDataMapper: null,
        onNavigation: () => {}
    };

    componentWillMount() {
        this.setState(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    tableHead() {
        return this.state.columns.length? <thead>
        <HRow class="text-center">
            {this.state.columns.map((col,i) => <HCell class="font-bold bg-gray-200" first={i===0}>{col}</HCell>)}
        </HRow>
        </thead>: null;
    }

    // noinspection JSCheckFunctionSignatures
    render() {
        const TotalNumberOfPages = Math.ceil(this.state.totalrecords/this.state.recordperpage);
        const rowsDataMapper = this.state.rowsDataMapper;
        const rowDataMapper = this.state.rowDataMapper === null && this.state.rowsDataMapper === null?
            item => item : (this.state.rowDataMapper === null? null : this.state.rowDataMapper);

        return <Panel class="overflow-x-auto">
            <PanelRow>
                {!this.state.data.length?
                    <div class="text-center text-lg text-gray-500">
                        <Trans>Non ci sono record da mostrare</Trans>
                    </div>
                    : <CustomTable style={this.state.style} class={this.state.class}>
                        {this.state.colGroupMapper !== false && <colgroup>{this.state.colGroupMapper}</colgroup>}
                        {this.tableHead()}
                        <tbody class="text-center">
                        {!!rowDataMapper && this.state.data.map((row,j) => rowDataMapper(row,j)).map(
                            cells => <Row class={this.state.rowClass}>
                                {cells.map((item,i) => <Cell first={!this.state.noFirstCell && i===0} class={!!this.state.cellClass? this.state.cellClass : "p-1"} borderColor="var(--main-color)">
                                    {!Array.isArray(item)? item : item.filter(subitem => subitem !== null).map(subitem => <div>{subitem}</div>)}
                                </Cell>)}
                            </Row>
                        )}
                        {!!rowsDataMapper && this.state.data.flatMap((row,j) => rowsDataMapper(row,j)).map(
                            cells => <Row class={this.state.rowClass}>
                                {cells.map((item,i) => <Cell first={!this.state.noFirstCell && i===0} colspan={cells.length===1? this.state.columns.length : 1} class={!!this.state.cellClass? this.state.cellClass : (cells.length===1? 'p-0' : 'p-1')} borderColor="var(--main-color)">
                                    {!Array.isArray(item)? item : item.filter(subitem => subitem !== null).map(subitem => <div>{subitem}</div>)}
                                </Cell>)}
                            </Row>
                        )}
                        </tbody>
                    </CustomTable>}
            </PanelRow>
            {this.state.onNavigation !== false && !!this.state.data.length && <PaginationV2
                pages={TotalNumberOfPages}
                currentPage={this.state.page}
                onNavigation={(page) => {this.state.onNavigation(page, page*this.state.recordperpage-this.state.recordperpage)}}
                isLastPage={TotalNumberOfPages===this.state.page}
            />}
        </Panel>;
    }
}
